import styled from "styled-components";
import { CheckBox } from "./Style";
import CustomTooltip from "shared/components/CustomTooltip";

interface FilterOptionProps {
	item: any;
	isSelected: boolean; // A boolean indicating if the item is selected
}

export const FilterOption: React.FC<FilterOptionProps> = ({ item, isSelected }) => {
	return (
		<CustomTooltip text={item?.name} placement="bottom" disabled={!item?.name}>
			<Container>
				<BoxContainer>
					<CheckBox type="checkbox" checked={isSelected} onChange={() => {}} />
				</BoxContainer>
				<Name>{item?.name}</Name>
			</Container>
		</CustomTooltip>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	:hover {
		cursor: pointer;
	}
`;

const BoxContainer = styled.div`
	width: 16px;
	height: 16px;
`;

const Name = styled.div`
	max-height: 40px;
	min-width: 100px;
	width: 100%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	color: #262626;
	font-style: normal;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-top: 8px;
`;
